import { semantic } from '../../../theme/tokens';

/** KPIs for the stores list. Only active stores are counted. */
export function computeStoreAnalytics(stores) {
    const activeStoresData = stores?.filter((s) => s.active === 'activo') || [];
    const activeStores = activeStoresData.length;

    // Count moderno/tradicional only from active stores
    const modernoStores = activeStoresData.filter((s) => s.channel === 'MODERNO')?.length || 0;
    const tradicionalStores = activeStoresData.filter((s) => s.channel === 'TRADICIONAL')?.length || 0;

    // Stores with coordinates (only active stores)
    const storesWithCoordinates = activeStoresData.filter((s) => s.coordinates?.latitude && s.coordinates?.longitude)?.length || 0;
    const coordinatesCoverage = activeStores > 0 ? Math.round((storesWithCoordinates / activeStores) * 100) : 0;

    // Stores with promotors assigned (only active stores)
    const storesWithPromotors = activeStoresData.filter((s) => s.promotorNames && s.promotorNames.length > 0)?.length || 0;
    const promotorCoverage = activeStores > 0 ? Math.round((storesWithPromotors / activeStores) * 100) : 0;

    return { activeStores, modernoStores, tradicionalStores, storesWithCoordinates, coordinatesCoverage, storesWithPromotors, promotorCoverage };
}

/** Coverage tone: ≥80% good, ≥50% attention, otherwise bad. */
export function coverageTone(value) {
    if (value >= 80) return 'success';
    if (value >= 50) return 'warning';
    return 'danger';
}

/** Progress bar color for a coverage tone (from the design tokens). */
export function coverageColor(value) {
    return semantic[coverageTone(value)].solid;
}
